<template lang="pug">
.waiter-label-setting-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：使用する／しない
    template(#cell(use)="row")
      PermittedFunctionSwitch(v-model="row.item.use")
    // セル：ラベル名
    template(#cell(name)="row")
      b-form-input(:id="'label-name-' + row.item.id" v-model="row.item.name" :name="'label-name-' + row.item.id"
        placeholder="ラベル名を入力してください" :maxlength="10" :class="[ { noinput: !row.item.name } ]"
        v-validate="{ required: true }" :data-vv-as="'ラベル' + row.item.id + 'のラベル名'")
      .error-messages(v-for="error in errors.collect('label-name-' + row.item.id)")
        .error-message {{ error }}
    // セル：説明文
    template(#cell(description)="row")
      b-form-input(:id="'label-description-' + row.item.id" v-model="row.item.description" :name="'label-description-' + row.item.id"
        placeholder="説明文を入力してください" :maxlength="100" v-validate="{ max: 100 }" :data-vv-as="'説明文' + row.item.id")
      .error-messages(v-for="error in errors.collect('label-description-' + row.item.id)")
        .error-message {{ error }}
    // セル：ラベル選択
    template(#cell(labelSelect)="row")
      b-form-select(v-model="row.item.colorId" :style="getStyle(row.item.colorId)")
        b-form-select-option(v-for="i in 10" :key="i" :value="i" :style="getStyle(i)") カラー{{ i }}
    // セル：プレビュー
    template(#cell(preview)="row")
      span.label-sample(:style="getStyle(row.item.colorId)") {{ row.item.name }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import PermittedFunctionSwitch from "@/pc/basics/PermittedFunctionSwitch.vue";
/**
 * ### 待機者ラベル選択テーブルコンポーネント
 */
@Component({
  components: {
    PermittedFunctionSwitch
  }
})
export default class WaiterLabelSettingTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<WaiterLabelSettingTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<WaiterLabelSettingTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<WaiterLabelSettingTableItem> {
    return this.value;
  }

  public getStyle(index: number): string {
    switch (index) {
      case 1: {
        return "background-color:#0091BF; color:#FFFFFF;";
      }
      case 2: {
        return "background-color:#00AF3A; color:#FFFFFF;";
      }
      case 3: {
        return "background-color:#DF5517; color:#FFFFFF;";
      }
      case 4: {
        return "background-color:#DECB05; color:#FFFFFF;";
      }
      case 5: {
        return "background-color:#F1396B; color:#FFFFFF;";
      }
      case 6: {
        return "background-color:#70D9F9; color:#000000;";
      }
      case 7: {
        return "background-color:#57E78F; color:#000000;";
      }
      case 8: {
        return "background-color:#ECAB8F; color:#000000;";
      }
      case 9: {
        return "background-color:#F1E583; color:#000000;";
      }
      case 10: {
        return "background-color:#F7B4C6; color:#000000;";
      }
    }
    return "";
  }
}

/** テーブルの列名の情報 */
export interface WaiterLabelSettingTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface WaiterLabelSettingTableItem {
  /** ラベルID */
  id: number;
  /** ラベル名 */
  name: string;
  /** 説明文 */
  description: string;
  /** 文字色 */
  color: string;
  /** 背景色 */
  bgColor: string;
  /** 使用可否 */
  use: boolean;

  /** 色ID */
  colorId: number;

  /** 更新日時 */
  updated: number;
}
</script>

<style lang="scss" scoped>
.waiter-label-setting-table-component {
  .label-sample {
    font-size: 12px;
    padding: 4px;
    border-radius: 0.25rem;
  }
}
</style>
